module.exports = __webpack_public_path__ + "img/404.e58087e0.svg";